import { cva } from "class-variance-authority";
import { cn } from "cn";
import type { FC, PropsWithChildren } from "react";
import React from "react";

import type { VariantProps } from "@react/ui-primitives/lib";

const variants = cva("", {
  defaultVariants: { edgeToEdge: false },
  variants: {
    edgeToEdge: { false: "[&>div]:mx-auto [&>div]:max-w-7xl", true: "" },
  },
});

interface PageContainerProps extends VariantProps<typeof variants> {}

export const PageContainer: FC<PropsWithChildren<PageContainerProps>> = ({
  children,
  edgeToEdge,
}) => (
  <main
    className={cn(
      "flex w-full flex-1 flex-col overflow-y-auto",
      variants({ edgeToEdge }),
    )}
    style={{ paddingBottom: "var(--safe-bottom, 0px)" }}
  >
    <div
      className={`
        flex w-full flex-1 flex-col px-4 py-6
        sm:px-6
        lg:px-8
      `}
    >
      {children}
    </div>
  </main>
);
